<div class="max-w-6xl mx-auto">
  <div class="bg-white rounded-lg shadow-md p-6">
    <h1 class="text-3xl font-bold text-slate-800 mb-6">
      Termine
    </h1>

    <div class="embed-responsive embed-responsive-4by3">
      <iframe
        class="embed-responsive-item rounded-lg border border-slate-200"
        style="width: 100%; height: 60em"
        src="https://cloud.sko-sued.de/index.php/apps/calendar/embed/nciiX3dxrijzTmDw"
        allowfullscreen>
      </iframe>
    </div>
  </div>
</div>
